let answerSequence = 0;

export const initFaqSections = (): void => {
  document.querySelectorAll<HTMLElement>('[data-faq]').forEach((faq) => {
    const toggles = Array.from(faq.querySelectorAll<HTMLButtonElement>('[data-faq-toggle]'));

    toggles.forEach((toggle) => {
      const item = toggle.closest<HTMLElement>('.faq__item');
      const answer = item?.querySelector<HTMLElement>('[data-faq-answer]');

      if (!answer) {
        return;
      }

      const answerId = `faq-answer-${answerSequence}`;
      answerSequence += 1;
      answer.id = answerId;
      toggle.setAttribute('aria-controls', answerId);

      toggle.addEventListener('click', () => {
        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

        toggles.forEach((otherToggle) => {
          const otherItem = otherToggle.closest<HTMLElement>('.faq__item');
          const otherAnswer = otherItem?.querySelector<HTMLElement>('[data-faq-answer]');

          otherToggle.setAttribute('aria-expanded', 'false');
          if (otherAnswer) {
            otherAnswer.hidden = true;
          }
        });

        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        answer.hidden = !willOpen;
      });
    });
  });
};
